import * as organizationSelectors from 'selectors/Organization';

export const types = {
  PROJECT_REQUEST: 'PROJECTS/PROJECT_REQUEST',
  PROJECT_SUCCESS: 'PROJECTS/PROJECT_SUCCESS',
  PROJECT_FAILURE: 'PROJECTS/PROJECT_FAILURE',
  PROJECTS_REQUEST: 'PROJECTS/PROJECTS_REQUEST',
  PROJECTS_SUCCESS: 'PROJECTS/PROJECTS_SUCCESS',
  PROJECTS_FAILURE: 'PROJECTS/PROJECTS_FAILURE',
  TOGGLE_AUTO_REVIEW_REQUEST: 'PROJECTS/TOGGLE_AUTO_REVIEW_REQUEST',
  TOGGLE_AUTO_REVIEW_SUCCESS: 'PROJECTS/TOGGLE_AUTO_REVIEW_SUCCESS',
  TOGGLE_AUTO_REVIEW_FAILURE: 'PROJECTS/TOGGLE_AUTO_REVIEW_FAILURE',
  BULK_TOGGLE_REVIEW_REQUEST: 'PROJECTS/BULK_TOGGLE_REVIEW_REQUEST',
  BULK_TOGGLE_REVIEW_SUCCESS: 'PROJECTS/BULK_TOGGLE_REVIEW_SUCCESS',
  BULK_TOGGLE_REVIEW_FAILURE: 'PROJECTS/BULK_TOGGLE_REVIEW_FAILURE',
  TOGGLE_APPROVALS_REQUEST: 'PROJECTS/TOGGLE_APPROVALS_REQUEST',
  TOGGLE_APPROVALS_SUCCESS: 'PROJECTS/TOGGLE_APPROVALS_SUCCESS',
  TOGGLE_APPROVALS_FAILURE: 'PROJECTS/TOGGLE_APPROVALS_FAILURE',
  TOGGLE_AUTOMATION_REQUEST: 'PROJECTS/TOGGLE_AUTOMATION_REQUEST',
  TOGGLE_AUTOMATION_SUCCESS: 'PROJECTS/TOGGLE_AUTOMATION_SUCCESS',
  TOGGLE_AUTOMATION_FAILURE: 'PROJECTS/TOGGLE_AUTOMATION_FAILURE',
  MARK_PROJECT_ONBOARDED_REQUEST: 'PROJECTS/MARK_PROJECT_ONBOARDED_REQUEST',
  MARK_PROJECT_ONBOARDED_SUCCESS: 'PROJECTS/MARK_PROJECT_ONBOARDED_SUCCESS',
  MARK_PROJECT_ONBOARDED_FAILURE: 'PROJECTS/MARK_PROJECT_ONBOARDED_FAILURE',
  UPDATE_BILLING_PLAN_REQUEST: 'PROJECTS/UPDATE_BILLING_PLAN_REQUEST',
  UPDATE_BILLING_PLAN_SUCCESS: 'PROJECTS/UPDATE_BILLING_PLAN_SUCCESS',
  UPDATE_BILLING_PLAN_FAILURE: 'PROJECTS/UPDATE_BILLING_PLAN_FAILURE',
  UPDATE_PROJECT_NOTES_REQUEST: 'PROJECTS/UPDATE_PROJECT_NOTES_REQUEST',
  UPDATE_PROJECT_NOTES_SUCCESS: 'PROJECTS/UPDATE_PROJECT_NOTES_SUCCESS',
  UPDATE_PROJECT_NOTES_FAILURE: 'PROJECTS/UPDATE_PROJECT_NOTES_FAILURE',
};

function keyForOrganization(providerId, slug) {
  return `${providerId}:${slug}`;
}

export const initialState = {
  error: null,
  errorCode: null,
  isLoading: false,
  isUpdating: false,
  byOrganization: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.MARK_PROJECT_ONBOARDED_REQUEST:
      return { ...state, isUpdating: true, error: null, errorCode: null };
    case types.MARK_PROJECT_ONBOARDED_SUCCESS:
      return { ...state, isUpdating: false };
    case types.MARK_PROJECT_ONBOARDED_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    case types.PROJECT_REQUEST:
      return { ...state, isLoading: true, error: null, errorCode: null };
    case types.PROJECT_SUCCESS:
      const { projectUUID, project: newProject } = action;
      return {
        ...state,
        isLoading: false,
        byOrganization: Object.keys(state.byOrganization).reduce((acc, key) => {
          const projectsSortedBy = state.byOrganization[key];
          acc[key] = Object.keys(projectsSortedBy).reduce((carry, sortBy) => {
            carry[sortBy] = projectsSortedBy[sortBy].map((p) =>
              p.uuid === projectUUID ? newProject : p
            );
            return carry;
          }, {});
          return acc;
        }, {}),
      };
    case types.PROJECT_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.PROJECTS_REQUEST:
      return { ...state, isLoading: true, error: null, errorCode: null };
    case types.PROJECTS_SUCCESS:
      const { projects, organizationSlug, providerId, key } = action;
      return {
        ...state,
        isLoading: false,
        byOrganization: {
          ...state.byOrganization,
          [keyForOrganization(providerId, organizationSlug)]: {
            ...state.byOrganization[
              keyForOrganization(providerId, organizationSlug)
            ],
            [key]: projects,
          },
        },
      };
    case types.PROJECTS_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.TOGGLE_AUTO_REVIEW_REQUEST:
      return { ...state, isUpdating: true, error: null, errorCode: null };
    case types.TOGGLE_AUTO_REVIEW_SUCCESS:
      return { ...state, isUpdating: false };
    case types.TOGGLE_AUTO_REVIEW_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    case types.BULK_TOGGLE_REVIEW_REQUEST:
      return { ...state, isUpdating: true, error: null, errorCode: null };
    case types.BULK_TOGGLE_REVIEW_SUCCESS:
      return { ...state, isUpdating: false };
    case types.BULK_TOGGLE_REVIEW_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    case types.TOGGLE_APPROVALS_REQUEST:
      return { ...state, isUpdating: true, error: null, errorCode: null };
    case types.TOGGLE_APPROVALS_SUCCESS:
      return { ...state, isUpdating: false };
    case types.TOGGLE_APPROVALS_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    case types.TOGGLE_AUTOMATION_REQUEST:
      return { ...state, isUpdating: true, error: null, errorCode: null };
    case types.TOGGLE_AUTOMATION_SUCCESS:
      return { ...state, isUpdating: false };
    case types.TOGGLE_AUTOMATION_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    case types.UPDATE_BILLING_PLAN_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_BILLING_PLAN_SUCCESS:
      return { ...state, isLoading: false };
    case types.UPDATE_BILLING_PLAN_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.UPDATE_PROJECT_NOTES_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.UPDATE_PROJECT_NOTES_SUCCESS:
      return { ...state, isUpdating: false };
    case types.UPDATE_PROJECT_NOTES_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    default:
      return state;
  }
};

export const actions = {
  fetchProjects: (providerId, organizationSlug, sortBy) => ({
    type: types.PROJECTS_REQUEST,
    providerId,
    organizationSlug,
    sortBy,
  }),
  fetchProject: (projectUUID) => ({
    type: types.PROJECT_REQUEST,
    projectUUID,
  }),
  bulkToggleAutoReview: (organization, enabled) => ({
    type: types.BULK_TOGGLE_REVIEW_REQUEST,
    organization,
    enabled,
  }),
  toggleApprovalsAllowed: (organization, projectUUID, enabled) => ({
    type: types.TOGGLE_APPROVALS_REQUEST,
    organization,
    projectUUID,
    enabled,
  }),
  toggleAutoReview: (organization, projectUUID, enabled) => ({
    type: types.TOGGLE_AUTO_REVIEW_REQUEST,
    organization,
    projectUUID,
    enabled,
  }),
  toggleAutomationResults: (projectUUID, enabled) => ({
    type: types.TOGGLE_AUTOMATION_REQUEST,
    projectUUID,
    enabled,
  }),
  markProjectOnboarded: (projectUUID, isOrgOnboarded, url) => ({
    type: types.MARK_PROJECT_ONBOARDED_REQUEST,
    projectUUID,
    isOrgOnboarded,
    url,
  }),
  updateProjectBillingPlan: (plan, projectUUID) => ({
    type: types.UPDATE_BILLING_PLAN_REQUEST,
    plan,
    projectUUID,
  }),
  updateProjectNotes: (projectUUID, notes) => ({
    type: types.UPDATE_PROJECT_NOTES_REQUEST,
    projectUUID,
    notes,
  }),
};

const projectsForOrganizationSelector = (state, providerId, slug) => {
  const orgProjects =
    state.projects.byOrganization[keyForOrganization(providerId, slug)];
  return orgProjects ? orgProjects['last_activity_at'] : null;
};

const projectsSelector = (state) => {
  const organization = organizationSelectors.organizationSelector(state);
  return projectsForOrganizationSelector(
    state,
    organization.providerId,
    organization.slug
  );
};

export const selectors = {
  projectsForOrganization: projectsForOrganizationSelector,
  projects: projectsSelector,
  sortedProjectsForOrganization: (state, providerId, slug) => {
    return state.projects.byOrganization[keyForOrganization(providerId, slug)];
  },
  getMatchedProject: (state, organization, projectName) => {
    const orgProjects = selectors.projectsForOrganization(
      state,
      organization.providerId,
      organization.slug
    );
    return orgProjects.find((project) => project.name === projectName);
  },
};
